<template>
    <!-- @detected-condition fires when the connectivity status of the device changes -->
    <offline @detected-condition="handleConnectivityChange">
        <!-- Only renders when the device is online -->
        <div slot="online">
            <p class="connectivity-status">Connected!</p>
        </div>
        <!-- Only renders when the device is offline -->
        <div slot="offline">
            <p class="connectivity-status">You appear to be offline.</p>
        </div>
    </offline>
</template>

<script>
    import offline from 'v-offline';

    export default {
        name: "HandleConnectivity",
        components: {
            offline
        },

        methods: {
            handleConnectivityChange(status) {
                // console.log(status);
            }
        }
    }
</script>

<style scoped>
.connectivity-status{
    background-color: #6D0606;
    color: #ffffff;
    padding: 10px 15px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 20px;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    z-index: 9999999999;
}
</style>